import Component from '../core/Component'
import Scroll from '../services/Scroll'
import EventBus from '../core/EventBus'
import {EVENTS} from '../core/Events'

export default class Bg extends Component {
    prepare() {
        Scroll.on('resize-x', this.handleResize)
        EventBus.on(EVENTS.SWUP_CONTENT_REPLACED, this.handleSwupContentReplaced)
        setTimeout(() => {
            this.resize()
        }, 3000)
        Scroll.on('scroll', this.handleScroll)
        this.element.addEventListener('transitionend', this.handleTransitionEnd)
    }

    destroy() {
        Scroll.off('resize-x', this.handleResize)
        Scroll.off('scroll', this.handleScroll)
        EventBus.off(EVENTS.SWUP_CONTENT_REPLACED, this.handleSwupContentReplaced)
    }

    handleTransitionEnd = () => {
        EventBus.emit(EVENTS.BG_TRANSITIONEND)
    }

    handleSwupContentReplaced = () => {
        this.resize()
    }

    handleResize = () => {
        this.resize()
    }

    handleScroll = () => {
        this.resize()
    }

    resize() {
        Scroll.off('scroll', this.handleScroll)
        
        const bgEl = document.querySelector('[data-bg]')
        let height = 0
        let isRounded = false
        let isSection = false
        if (bgEl && bgEl.dataset.bg === 'hidden') {
            height = 0
        }
        else if (bgEl) {
            const scrollY = Scroll.getScroll().y
            const bgRect = bgEl.getBoundingClientRect()
            height = scrollY + bgRect.top + bgRect.height
            isRounded = bgEl.dataset.bgNoradius === undefined
            isSection = true
        } else {
            height = document.querySelector('.Header')?.getBoundingClientRect().height ?? 0
        }
        this.element.style.height = `${height}px`
        this.element.classList.toggle('is-rounded', isRounded)
        this.element.classList.toggle('is-section', isSection)
        this.element.classList.add('is-ready')
    }
}
